import {Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomErrorstatematcherComponent } from '../../ui-elements/input/custom-errorstatematcher/custom-errorstatematcher.component';
import { FeathericonsModule } from '../../icons/feathericons/feathericons.module';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { ContactService } from '../../ds-pages/services/contact.service';
import { ToastrService } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppStateService } from '../../ds-pages/state/app-state.service';

@Component({
  selector: 'app-contact-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CustomErrorstatematcherComponent, 
    ReactiveFormsModule, 
    FeathericonsModule,
    MatCardModule,
    CommonModule,
    MatSelectModule,
    MatProgressSpinnerModule
    ],
  templateUrl: './contact-dialog.component.html',
  styleUrl: './contact-dialog.component.scss'
})
export class ContactDialogComponent {

  organization?: string;
  email?: string;

  contactForm: FormGroup = this.formBuilder.group({
    asunto: ['', [Validators.required]],
    texto: ['', [Validators.required]],
  });

  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<ContactDialogComponent>,
    private formBuilder: FormBuilder,
    private _contactService: ContactService,
    private _toastr: ToastrService,
    private _state: AppStateService,
  ) {}

  ngOnInit(): void {
    const state = this._state.getState()();
    
    this.organization = state.organization;
    this.email = state.email;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  enviar(): void {
    this.isLoading = true;

    if (this.contactForm.invalid) {
      this._toastr.error("Por favor complete todos los campos requeridos.")
      this.isLoading = false;
      return;
    }

    this._contactService.postContact(this.organization!, this.email!, this.contactForm.value).subscribe({
      next: (res) => {
        this._toastr.success(res.message || "Solicitud enviada correctamente, se le responderá en el correo asociado a esta cuenta.");
        this.dialogRef.close();
        this.isLoading = false;
      },
      error: () => {
        this._toastr.error("Ocurrió un error al enviar su solicitud, por favor intente nuevamente más tarde.");
        this.isLoading = false;
      }
    });
  }
}
